import React from "react";
import { Box, Typography, IconButton } from "../../../design-system";
import { CloseIcon } from "../../../design-system/icons";
import { colors } from "../../../design-system/colors";
import { UPLOAD_AREA_LAYOUT } from "../constants/uploadAreaLayout";

interface SelectedFilePreviewProps {
  file: File;
  onClear: () => void;
}

const SelectedFilePreview: React.FC<SelectedFilePreviewProps> = ({ file, onClear }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      width: "100%",
      maxWidth: `${UPLOAD_AREA_LAYOUT.urlInputWidth}px`,
      paddingLeft: "4px",
    }}
  >
    <Typography
      sx={{
        fontSize: "14px",
        fontWeight: 300,
        color: colors.neutral.white,
        fontFamily: "Outfit, sans-serif",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {file.name}
    </Typography>
    <IconButton
      ariaLabel="Clear file"
      onClick={onClear}
      size={20}
      sx={{
        padding: "5px",
        color: colors.neutral.white,
        backgroundColor: colors.input.clearButtonBg,
        borderRadius: "100px",
      }}
    >
      <CloseIcon />
    </IconButton>
  </Box>
);

export default SelectedFilePreview;
